import React from 'react';
import Icon from 'components/AppIcon';

const ProblemSlide = () => {
  const problems = [
    {
      icon: 'MapPin',
      title: 'Limited Access in Rural Areas',
      description: 'Many Kenyans in rural areas struggle to find qualified legal representation',
      impact: '60% of population underserved'
    },
    {
      icon: 'Search',
      title: 'Difficulty Finding Specialized Lawyers',
      description: 'Clients struggle to identify lawyers with specific expertise for their legal matters',
      impact: 'Leads to poor case outcomes'
    },
    {
      icon: 'FileText',
      title: 'Inefficient Case Management',
      description: 'Law firms rely on manual processes, leading to delays and miscommunication',
      impact: 'Average case 40% longer'
    },
    {
      icon: 'Eye',
      title: 'Lack of Transparency',
      description: 'Clients have limited visibility into case progress and legal proceedings',
      impact: 'Low client satisfaction'
    },
    {
      icon: 'MessageSquare',
      title: 'Communication Barriers',
      description: 'Poor communication channels between lawyers and clients',
      impact: 'Missed deadlines & updates'
    },
    {
      icon: 'Clock',
      title: 'Manual Document Management',
      description: 'Paper-based systems lead to document loss and version control issues',
      impact: 'Critical delays in cases'
    }
  ];

  return (
    <div className="py-12">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-heading font-bold text-text-primary mb-4">
            The Problem We're Solving
          </h1>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            Kenya's legal system faces significant challenges that prevent efficient delivery of legal services
          </p>
        </div>

        {/* Problem Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {problems?.map((problem, index) => (
            <div key={index} className="bg-surface rounded-lg p-6 shadow-card border border-border hover:shadow-lg transition-smooth">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-accent-50 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name={problem?.icon} size={24} className="text-accent" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-heading font-semibold text-text-primary mb-2">
                    {problem?.title}
                  </h3>
                  <p className="text-text-secondary mb-3 text-sm leading-relaxed">
                    {problem?.description}
                  </p>
                  <div className="inline-flex items-center px-3 py-1 bg-warning-50 text-warning-600 rounded-full text-xs font-medium">
                    {problem?.impact}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Key Statistics */}
        <div className="bg-accent-50 rounded-lg p-8">
          <h2 className="text-2xl font-heading font-bold text-text-primary mb-6 text-center">
            The Impact of These Problems
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-3xl font-heading font-bold text-accent mb-2">15,000+</div>
              <p className="text-text-secondary">Practicing lawyers in Kenya</p>
            </div>
            <div className="text-center">
              <div className="text-3xl font-heading font-bold text-accent mb-2">50M+</div>
              <p className="text-text-secondary">Potential clients needing legal services</p>
            </div>
            <div className="text-center">
              <div className="text-3xl font-heading font-bold text-accent mb-2">70%</div>
              <p className="text-text-secondary">Of legal matters resolved inefficiently</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProblemSlide;